import localStorageService from "../services/localStorage";
import { CLIENT_ID, FEATURE_FLAGS_STRING } from "../constants/config";
import { FEATURE_FLAGS } from "@/constants/featureFlagsConstants";

// this is needed for an edge case where moving from studies list react app to the vue app does not load the feature flag to state fast enough
export const isFeatureEnabled = flag => {
  const featureFlags = localStorageService.getItem(FEATURE_FLAGS_STRING);
  const clientId = localStorageService.getItem(CLIENT_ID);
  const feature = featureFlags[flag];

  if (feature && feature.enabled) {
    // if flag exists and feature is enabled
    // check if customer is enabled
    if (feature.customers && Array.isArray(feature.customers)) {
      return feature.customers.length === 0 || feature.customers.includes(clientId);
    } else {
      // customers is undefined
      return true;
    }
  }

  return false;
};

export function isTestPortalEnabled() {
  return isFeatureEnabled(FEATURE_FLAGS.TEST_PORTAL);
}
